export const UserArrowRight = ({ fill = "#0037ff" }: { fill?: string }) => (
    <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.076 3.99329C11.076 6.21204 9.26355 7.99329 7.07605 7.99329C4.8573 7.99329 3.07605 6.21204 3.07605 3.99329C3.07605 1.80579 4.8573 -0.00670624 7.07605 -0.00670624C9.26355 -0.00670624 11.076 1.80579 11.076 3.99329ZM10.076 3.99329C10.076 2.36829 8.70105 0.993294 7.07605 0.993294C5.4198 0.993294 4.07605 2.36829 4.07605 3.99329C4.07605 5.64954 5.4198 6.99329 7.07605 6.99329C8.70105 6.99329 10.076 5.64954 10.076 3.99329Z"
            fill={fill}
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.4823 9.49329H8.63855C11.6385 9.49329 14.076 11.9308 14.076 14.9308C14.076 15.5245 13.576 15.9933 12.9823 15.9933H1.13855C0.5448 15.9933 0.0760498 15.5245 0.0760498 14.9308C0.0760498 11.9308 2.4823 9.49329 5.4823 9.49329ZM1.13855 14.9933H12.9823C13.0135 14.9933 13.076 14.962 13.076 14.9308C13.076 12.4933 11.076 10.4933 8.63855 10.4933H5.4823C3.0448 10.4933 1.07605 12.4933 1.07605 14.9308C1.07605 14.962 1.1073 14.9933 1.13855 14.9933Z"
            fill={fill}
        />
        <path
            d="M17.2543 9.73414L19.7543 7.23414C19.9574 7.04664 19.9574 6.71851 19.7543 6.53101L17.2543 4.03101C17.0668 3.82789 16.7386 3.82789 16.5511 4.03101C16.348 4.21851 16.348 4.54664 16.5511 4.73414L18.1918 6.37476H13.4105C13.1293 6.37476 12.9105 6.60914 12.9105 6.87476C12.9105 7.15601 13.1293 7.37476 13.4105 7.37476H18.1918L16.5511 9.03101C16.348 9.21851 16.348 9.54664 16.5511 9.73414C16.6449 9.82789 16.7699 9.87476 16.9105 9.87476C17.0355 9.87476 17.1605 9.82789 17.2543 9.73414Z"
            fill={fill}
        />
    </svg>
);
export default UserArrowRight;

UserArrowRight.displayName = "UserArrowRight";
